import _ from 'lodash'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import App from './App.vue'
import store from '@/vuex/store'
import Settings from '@/config/Settings'
import { mappingRoutes } from '@/Route.js'
import Translation from '@/core/mixins/Translation'
import LangMixin from '@/core/mixins/Lang'
import '@/core/js/Copyright'
import isMobile from 'ismobilejs'
import axios from 'axios'
import VueAxios from 'vue-axios'
 
Vue.use(VueAxios, axios)
Vue.use(VueRouter)
Vue.use(Meta,{ keyName: 'head' })
Vue.mixin(Translation)
Vue.config.productionTip = false

// gradient 90° : #4E3C99 => 50% && #20252A 
// gradient 90° : #7654BF => 34% && #936CCF 
// gradient 90° : #B3CC34 => 64% && #8DA31D 
// purple : #916AC9

const routes = [
    { 
        id: 'experience', 
        name: 'experience', 
        component: 'Experience', 
        fr: "/accueil/:section?/:step?",
        en: "/home/:section?/:step?"
    },
    { 
        id: 'prototype', 
        name: 'prototype', 
        component: 'Prototype', 
        fr: "/prototype_fr/:model?",
        en: "/prototype/:model?"
    }    
]

const router = new VueRouter({
    mode: 'history',
    routes: mappingRoutes(routes)
})

// console.log(router);

new Vue({
    router,
    store,
    mixins: [ LangMixin ],
    head() {
        return {
            htmlAttrs: { lang: this.lang },
            title: 'DPT-DEFAULT',
            titleTemplate: '%s | Prototype'
      }
    },
    data: () => ({
        reading: 'null',
        width: window.innerWidth,
        height: window.innerHeight,
        isDev: process.env.NODE_ENV !== 'production',
        isProd: process.env.NODE_ENV === 'production',
        isDesk: window.innerWidth >= 1024 ? true : false,
        iOS: null

    }),
    computed: {
        route() { 
            return this.$store.getters['app/route'] 
        }
    },
    beforeCreate() {
        this.$store.commit('app/LANG_CHANGED', this.$route.meta.lang)
        this.$store.commit('app/SET_FROM_ROUTE', this.$route)
        this.$store.commit('app/SET_TO_ROUTE', this.$route)
    },
    created() {
        this.$sizes =  {
            phone: 767,
            tabletPortrait: 768,
            tablet: 1024,
        }
        window.addEventListener('resize', this.onResize)
    },
    mounted: async function() {
        axios({
            method: 'get',
            url: 'https://api.wbloomdev.com/api/get/ugc',
            headers: {  'api-key': 'J7LTPxyAhqEXxkuqF7aJRA' }
        })
        .then( (res)=> {
            _.each(res.data.data, (o)=>{

                console.log(o);

                if(o.type == 'plaintext' && this.reading == 'null')
                    this.reading = o.plaintext
            })

            console.log(this.reading);
        })

        this.iOS = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0
        this.onResize()
    },
    methods: {
        onResize() {
            this.width = window.innerWidth
            this.height = window.innerHeight
        },
        below(type) { return this.width <= this.$sizes[type] },
        above(type) { return this.width >= this.$sizes[type] }
    },
    render: h => h(App)
}).$mount('#app')


